import Ajax from 'js/utils/ajax/ajax.js';

export const getSystemInfo = () => Ajax.get('/systeminfo/v1');

export const updateSystemInfo = (systemInfo) => Ajax.put('/systeminfo/v1', systemInfo);
